export default __webpack_public_path__ + "static/media/aj6.9179997a.png";